module.exports = function () {
    return function (input) {
        return (input) ? input.split(' > ')[input.split(' > ').length - 1] : '';
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/filters/bws-link-text.js
 **/